<template>
  <div>
    <v-container class="col-11 ml-0 mt-10 pl-0 pb-7">
      <v-row :style="searchHeight" class="mb-4 ml-0" cols="12">
        <v-col cols="2" class="pl-0">
          <v-select
            v-model="searchPayload.range_type"
            :items="dateTypeItems"
            label="Select"
            persistent-hint
            single-line
            :style="searchHeight"
            outlined
            dense
            class="pt-0"
          ></v-select>
        </v-col>
        <v-col cols="4">
          <v-menu
            v-model="startMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                outlined
                v-model="searchPayload.from"
                readonly
                v-on="on"
                dense
                :style="textFileSize"
                class="d-inline-block mr-1"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="searchPayload.from"
              @input="startMenu = false"
              locale="ko"
              :max="searchPayload.to"
            ></v-date-picker> </v-menu
          >~
          <v-menu
            v-model="endMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                outlined
                v-model="searchPayload.to"
                readonly
                v-on="on"
                dense
                :style="textFileSize"
                class="d-inline-block mr-1"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="searchPayload.to"
              @input="endMenu = false"
              locale="ko"
              :min="searchPayload.from"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="2" :style="searchHeight" class="pb-0 pt-6 pl-0"
          >인증상태</v-col
        >
        <v-col cols="4" class="pt-3" height="50px">
          <v-select
            v-model="searchPayload.cert_status"
            :items="authStateItems"
            label="Select"
            persistent-hint
            single-line
            class="pt-0"
            outlined
            dense
            :style="{ width: '94%' }"
          ></v-select>
        </v-col>
      </v-row>
      <v-row :style="searchHeight" class="mb-4 ml-0" cols="12">
        <v-col cols="2" class="pl-0">
          <v-select
            v-model="searchPayload.search_type"
            :items="codeItems"
            label="Select"
            persistent-hint
            single-line
            class="pt-0"
            outlined
            dense
            @change="changeSearchType"
          ></v-select>
        </v-col>
        <v-col cols="4">
          <v-text-field
            v-model="searchPayload.search_value"
            outlined
            dense
            class="mr-1"
            :placeholder="searchValuePlaceholder"
            :style="{ width: '86%' }"
            @keypress.enter="execSearch(true)"
          ></v-text-field>
        </v-col>
        <v-col cols="2" class="mt-3 pl-0">상품명</v-col>
        <v-col cols="4" class="pr-0">
          <v-text-field
            outlined
            dense
            class="mr-1"
            placeholder="상품명 입력"
            full-width
            :style="{ width: '92%' }"
            v-model="searchPayload.product_name"
            @keypress.enter="execSearch(true)"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="mb-0 ml-0" cols="12">
        <v-col cols="2" :style="searchHeight" class="pb-0 pt-6 pl-0"
          >정품 인증 코드</v-col
        >
        <v-col cols="4">
          <v-text-field
            outlined
            dense
            class="mr-1"
            placeholder="정품인증코드 - 없이 입력 가능"
            v-model="searchPayload.serial_number"
            :style="{ width: '86%' }"
            @keypress.enter="execSearch(true)"
          ></v-text-field>
        </v-col>
        <v-col cols="2" class="mt-3 pl-0 pr-0">
          <p class="pt-0 mt-0 mb-0">정품 인증 회원ID</p>
        </v-col>
        <v-col cols="4" class="pr-0">
          <v-text-field
            v-model="searchPayload.member_id"
            outlined
            dense
            class="mr-1"
            placeholder="아이디 입력"
            :style="{ width: '92%' }"
            @keypress.enter="execSearch(true)"
          ></v-text-field>
        </v-col>
      </v-row>
      <div class="row justify-center mb-10">
        <v-btn
          large
          color="grey darken-4"
          class="white--text"
          width="100"
          @click.prevent="execSearch(true)"
          >조회</v-btn
        >
        <v-btn
          large
          style="margin-left: 20px;"
          width="100"
          @click.prevent="resetSearch"
          >초기화</v-btn
        >
      </div>
    </v-container>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data() {
    return {
      textFileSize: {
        height: "50px",
        width: "110px"
      },
      searchHeight: {
        height: "50px"
      },
      dateTypeItems: [
        { text: "생성일자", value: "created_at" },
        { text: "인증일자", value: "activated_at" }
      ],
      authStateItems: [
        { text: "전체", value: "" },
        { text: "미인증", value: "inactivated" },
        { text: "인증완료", value: "activated" },
        { text: "승인완료", value: "approved" },
        { text: "분실", value: "lost" }
      ],
      codeSelected: { state: "상품코드" },
      codeItems: [
        { text: "상품코드", value: "product_code" },
        { text: "자체상품코드", value: "custom_product_code" },
        { text: "품목코드", value: "variant_code" },
        { text: "자체품목코드", value: "custom_variant_code" }
      ],
      startDate: new Date().toISOString().substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      modal: false,
      startMenu: false,
      endMenu: false,
      searchValuePlaceholder: "상품코드 입력",
      searchPayload: {
        product_name: "",
        cert_status: "",
        search_type: "product_code",
        search_value: "",
        range_type: "created_at",
        from: "",
        to: "",
        serial_number: "",
        member_id: "",
        limit: 20,
        offset: 0
      }
    };
  },
  mixins: [CommonMixin],
  created: function() {
    this.eventHub.$on("execSearch", this.execSearch);
    this.eventHub.$on("getPayload", this.getPayload);
  },
  methods: {
    /**
     * 검색
     */
    execSearch: function(init = false) {
      this.$nextTick(function() {
        if (init === true) {
          this.$parent.$refs.listComponent.options = {
            page: 1,
            itemsPerPage: this.searchPayload.limit
          };
        } else {
          let { page, itemsPerPage } = this.$parent.$refs.listComponent.options;
          this.searchPayload.offset = (page - 1) * itemsPerPage;
          this.searchPayload.limit = itemsPerPage;
          this.getProductList(this.searchPayload);
        }
      });
    },
    resetSearch: function() {
      this.searchPayload = {
        product_name: "",
        cert_status: "",
        search_type: "product_code",
        search_value: "",
        range_type: "created_at",
        from: "",
        to: "",
        serial_number: "",
        member_id: "",
        limit: 20,
        offset: 0
      };
      let befor1Month = new Date();
      befor1Month.setMonth(befor1Month.getMonth() - 1);

      let toDay = new Date();
      this.searchPayload.from = M.yyyymmdd(befor1Month);
      this.searchPayload.to = M.yyyymmdd(toDay);
    },
    /**
     * 검색내용 훔치기
     */
    getPayload: function() {
      return this.searchPayload;
    },
    /**
     * 상품 가져오기
     */
    getProductList: async function(payload) {
      this.$parent.$refs.listComponent.tableLoading = true;
      let data = await M.api(M.entry("/cert/serials/search"), payload);

      //this.eventHub.$emit("setList", data);
      this.$parent.$refs.listComponent.setProductList(data);
    },
    /**
     * 검색어 타입 수정
     **/
    changeSearchType: function() {
      let placeholderData = {
        product_code: "상품코드 입력",
        custom_product_code: "자체상품코드 입력",
        variant_code: "품목코드 입력",
        custom_variant_code: "자체품목코드 입력"
      };
      this.searchValuePlaceholder =
        placeholderData[this.searchPayload.search_type];
    }
  },
  mounted: function() {
    let befor1Month = new Date();
    befor1Month.setMonth(befor1Month.getMonth() - 1);
    let toDay = new Date();
    /**
     * 정품인증 코드 생성 -> 확인하러가기 createAuth 파라메터
     */
    if (this.$route.query.createAuth && this.$route.query.createAuth == "Y") {
      this.searchPayload.from = M.yyyymmdd(toDay);
      this.searchPayload.cert_status = "inactivated";
    } else {
      this.searchPayload.from = M.yyyymmdd(befor1Month);
    }
    this.searchPayload.to = M.yyyymmdd(toDay);
  }
};
</script>
